import { render } from "./editNotificationCC.vue?vue&type=template&id=6dd02c1c"
import script from "./editNotificationCC.vue?vue&type=script&lang=js"
export * from "./editNotificationCC.vue?vue&type=script&lang=js"

import "./editNotificationCC.vue?vue&type=style&index=0&id=6dd02c1c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__